module.exports = __webpack_public_path__ + "img/avi.20289dbc.png";